export default __webpack_public_path__ + "static/media/paid-invoice.9a6e28ad.svg";